import { MessageDescriptor, useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import AuthForm from '@/components/authForm/AuthFormRefresh';
import { useAuthPrompt, type AuthPrompt } from '@/context/auth/AuthPromptProvider';
import { User } from '@/store/user/types';

import messages from './messages';
import { Card, HeaderTextWrapper } from './styles';

type AuthFormWrapperProps = {
	heading?: (authPrompt: AuthPrompt) => {
		message: MessageDescriptor;
	};
	onAuthSuccess: (user: User) => void;
	requiresDataSharing?: boolean;
};

const AuthFormWrapper = ({ heading, onAuthSuccess, requiresDataSharing }: AuthFormWrapperProps) => {
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();
	const isSignup = authPrompt === 'signup';

	function buildHeading() {
		if (heading) {
			const { message = {} } = heading(authPrompt);
			return formatMessage(message);
		}
	}

	return (
		<Card>
			{heading && (
				<HeaderTextWrapper $isSignup={isSignup}>
					<Text align="center" noMargin el="h1" weight={FontWeights.Medium} size={FontSizes.lg}>
						{buildHeading()}
					</Text>
					{isSignup && (
						<Text align="center" size={FontSizes.base}>
							{formatMessage(messages.subHeading)}
						</Text>
					)}
				</HeaderTextWrapper>
			)}
			<AuthForm
				customEventProps={{ source: 'b2b' }}
				onAuthSuccess={onAuthSuccess}
				requiresDataSharing={requiresDataSharing}
			/>
		</Card>
	);
};

export default AuthFormWrapper;
